// extracted by mini-css-extract-plugin
export default {"box":"V5Tefj7Xhc8_uaRaq62r"};